import type { AmountUnit } from '@/utils';
import {
  type ContextType,
  type Dispatch,
  type FC,
  type PropsWithChildren,
  type SetStateAction,
  createContext,
  useContext,
  useState,
} from 'react';

const UnitContext = createContext<
  | {
      unit: AmountUnit;
      setUnit: Dispatch<SetStateAction<AmountUnit>>;
    }
  | undefined
>(undefined);

const useUnitContext = (): NonNullable<ContextType<typeof UnitContext>> => {
  const context = useContext(UnitContext);
  if (!context) {
    throw Error('useLocaledUnit must be used within AmountUnitProvider.');
  }

  return context;
};

export const useLocaledAmount = () => {
  const { unit } = useUnitContext();

  return {
    unit,
  };
};

export const AmountUnitProvider: FC<
  PropsWithChildren<{ initialValue?: AmountUnit }>
> = ({ children, initialValue = 'thousand' }) => {
  const [unit, setUnit] = useState<AmountUnit>(initialValue);

  return (
    <UnitContext.Provider value={{ unit, setUnit }}>
      {children}
    </UnitContext.Provider>
  );
};
